import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchTeamMembers = createAsyncThunk('team/fetchMembers', async () => {
  const res = await axios.get('/team');
  return res.data;
});

export const inviteTeamMember = createAsyncThunk('team/invite', async ({ inviteData }) => {
  const res = await axios.post('/team/invite', inviteData);
  return res.data;
});

export const updateMemberRole = createAsyncThunk('team/updateRole', async ({ userId, roleData }) => {
  const res = await axios.put(`/team/${userId}/role`, roleData);
  return res.data;
});

export const removeTeamMember = createAsyncThunk('team/remove', async ({ userId }) => {
  const res = await axios.delete(`/team/${userId}`);
  return res.data;
});

export const fetchPendingInvites = createAsyncThunk('team/fetchInvites', async () => {
  const res = await axios.get('/team/invites');
  return res.data;
});

const teamSlice = createSlice({
  name: 'team',
  initialState: { 
    members: [], 
    invites: [], 
    status: 'idle', 
    error: null 
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchTeamMembers.pending, (s) => { s.status = 'loading'; })
     .addCase(fetchTeamMembers.fulfilled, (s, a) => { s.status = 'succeeded'; s.members = a.payload; })
     .addCase(fetchTeamMembers.rejected, (s, a) => { s.status = 'failed'; s.error = a.error.message; })
     .addCase(inviteTeamMember.fulfilled, (s) => { s.status = 'idle'; })
     .addCase(updateMemberRole.fulfilled, (s) => { s.status = 'idle'; })
     .addCase(removeTeamMember.fulfilled, (s) => { s.status = 'idle'; })
     .addCase(fetchPendingInvites.fulfilled, (s, a) => { s.invites = a.payload; });
  }
});

export default teamSlice.reducer;
